/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid200,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid404,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParams,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidQueryResponse,
} from "../../types/courseRegistrationAssociatedCompanyDocumentApprovalController/GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid.ts";
import { associatedCompanyDocumentApprovalViewerViewModelSchema } from "../associatedCompanyDocumentApprovalViewerViewModelSchema.ts";

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid200Schema =
  z.lazy(
    () => associatedCompanyDocumentApprovalViewerViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500>;

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidQueryResponse>;
